export enum PageEditModeStatus {

    INIT, STARTED, PENDING, FINISHED

}
